var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#252525",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M14 14.5h-1.04v-1h-1.3v-2.556c0-.675-.349-1.302-.933-1.676L7.969 7.5l2.758-1.768a1.992 1.992 0 0 0 .933-1.676V1.5h1.3v-1H14V0H1v.5h1.04v1h1.3v2.556c0 .675.349 1.301.933 1.676L7.031 7.5 4.273 9.268a1.992 1.992 0 0 0-.933 1.676V13.5h-1.3v1H1c.005.074 0 .378 0 .5h13c-.003-.183 0-.342 0-.5zM4.561 5.316a1.498 1.498 0 0 1-.701-1.26V1.5h7.28v2.556c0 .507-.262.978-.701 1.26L7.5 7.199 4.561 5.316zm-.701 5.628c0-.507.262-.978.701-1.26L7.5 7.801l2.939 1.883c.439.282.701.753.701 1.26V13.5H3.86v-2.556z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.86 5.012h7.056l-3.4 2.405zM3.99 11.606h7.068l.25.123v1.877H3.686v-1.877z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7h1v5H7z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.d5bb402c.svg";
export { ForwardRef as ReactComponent };